import Tooltip from '@mui/material/Tooltip'

const navigation = (userRole) => {
  const isCampaigner = userRole === 'campaigner'

  return [
    {
      title: 'Home',
      path: '/home',
      icon: 'mdi:home-outline',
      iconOnly: true,
      iconBgColor: 'transparent',
      iconColor: '#ffffff'
    },
    {
      title: (
        <Tooltip title='Customer Data Platform' arrow placement='top'>
          <span>CDP</span>
        </Tooltip>
      ),
      icon: 'mdi:users',
      children: [
        {
          title: 'Audience',
          icon: 'mdi:account-group',
          path: '/customer-data-platform/all-audience',
          subtitle: 'Manage and organize customer profiles with detailed insights and analytics',
          iconColor: '#5b78b5',
          iconBgColor: '#e8eef9'
        },
        {
          title: 'Segment',
          icon: 'mdi:filter-variant',
          path: '/customer-data-platform/segment',
          subtitle: 'Create targeted customer groups based on behavior and attributes',
          iconColor: '#e67e22',
          iconBgColor: '#fef3e7'
        },
        {
          title: 'Data Integration',
          icon: 'mdi:database-sync',
          path: '/customer-data-platform/data-integration',
          subtitle: 'Connect and sync data from multiple sources and platforms',
          iconColor: '#16a085',
          iconBgColor: '#e8f8f5'
        }
      ]
    },
    {
      title: 'Content',
      icon: 'mdi:file-table-outline',
      children: [
        {
          title: 'Templates',
          icon: 'mdi:file-document-multiple',
          path: '/content/templates',
          subtitle: 'Browse and manage all your content templates across channels',
          iconColor: '#8e44ad',
          iconBgColor: '#f4ecf7'
        },
        {
          title: 'Media Library',
          icon: 'mdi:play-box-multiple',
          path: '/content/media-library',
          subtitle: 'Upload and manage media assets for your campaigns',
          iconColor: '#e74c3c',
          iconBgColor: '#fadbd8'
        }
      ]
    },
    {
      title: 'Engagement',
      icon: 'mdi:account-voice',
      children: [
        {
          title: 'Promotional Campaign',
          icon: 'mdi:bullhorn',
          path: '/engagement/promotional-campaign/campaign',
          subtitle: 'Launch and manage marketing campaigns to drive customer engagement',
          iconColor: '#e74c3c',
          iconBgColor: '#fadbd8'
        },
        {
          title: 'Transactional Campaign',
          icon: 'mdi:email-fast',
          path: '/engagement/transactional-campaign/campaign',
          subtitle: 'Send automated transactional notifications and alerts to customers',
          iconColor: '#27ae60',
          iconBgColor: '#eafaf1'
        },
        {
          title: 'Marketing Automation',
          icon: 'mdi:sitemap-outline',
          path: '/engagement/marketing-automation/journeys',
          subtitle: 'Build and automate personalized customer journey workflows',
          iconColor: '#f39c12',
          iconBgColor: '#fef5e7'
        }
      ]
    },
    {
      title: (
        <Tooltip title='Insights' arrow placement='top'>
          <span>Insights</span>
        </Tooltip>
      ),
      icon: 'mdi:report-box-outline',
      children: [
        {
          title: 'Campaign Report',
          icon: 'mdi:chart-line',
          path: '/campaign-report',
          subtitle: 'Analyze campaign performance and audience engagement metrics',
          iconColor: '#3498db',
          iconBgColor: '#ebf3fd'
        },

        {
          title: 'Advanced Analytics',
          icon: 'mdi:google-analytics',
          path: '/advanced-analytics',
          subtitle: 'Deep dive into advanced analytics and business intelligence insights',
          iconColor: '#e74c3c',
          iconBgColor: '#fadbd8'
        },
        {
          title: 'Custom Report',
          icon: 'mdi:file-chart',
          path: '/custom-report',
          subtitle: 'Create a downloadable custom report.',
          iconColor: '#9b59b6',
          iconBgColor: '#f4ecf7'
        },
      ]
    },
    ...(!isCampaigner ? [{
      title: 'Setting',
      icon: 'mdi:cog-outline',
      children: [
        {
          title: 'User',
          icon: 'mdi:account-cog',
          path: '/administration/user',
          subtitle: 'Manage user accounts, roles, and permissions across the platform',
          iconColor: '#34495e',
          iconBgColor: '#ecf0f1'
        },
        {
          title: 'Account',
          icon: 'mdi:cog',
          path: '/administration/setting',
          subtitle: 'Configure system preferences and platform options',
          iconColor: '#95a5a6',
          iconBgColor: '#f8f9fa'
        }
      ]
    }] : [])
  ]
}

export default navigation
